import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#f4f4f4] py-12 md:py-20 px-6">
      <div className="max-w-4xl mx-auto bg-white border-[4px] border-black p-8 md:p-16 brutal-shadow text-left">
        <header className="border-b-[4px] border-black pb-8 mb-12">
          <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter leading-none mb-4 text-black">
            Terms of Service
          </h1>
          <div className="inline-block bg-black text-white px-4 py-1 font-black uppercase text-sm">
            Effective Date: 27.07.2026
          </div>
        </header>

        <div className="space-y-12 font-medium text-lg leading-relaxed text-gray-800">
          <section>
            <p className="mb-6 italic font-bold">
              Welcome to ETERA. By using our website and purchasing our services, you agree to be bound by the following Terms of Service. Please read them carefully.
            </p>
          </section>

          <section>
            <h2 className="text-2xl md:text-3xl font-black uppercase mb-6 text-black tracking-tight">
              1. The Service and "Permanent" Links
            </h2>
            <p>
              ETERA provides dynamic QR code generation and link redirection services. A "Permanent" or "Eternal" link is defined as a dynamic redirect that will remain active for the duration of ETERA's operational lifecycle. While we intend to maintain the service indefinitely, the term "Permanent" applies only to the lifespan of the company and does not constitute a legal guarantee of infinite existence.
            </p>
          </section>

          <section>
            <h2 className="text-2xl md:text-3xl font-black uppercase mb-6 text-black tracking-tight">
              2. Pricing and Payments
            </h2>
            <p>
              ETERA operates on a single-payment model. The purchase price for a QR code is a one-time fee. Once a QR code is purchased, no further subscription fees are required to keep the link active or to change the destination URL.
            </p>
          </section>

          <section>
            <h2 className="text-2xl md:text-3xl font-black uppercase mb-6 text-black tracking-tight">
              3. Acceptable Use and Anti-Abuse
            </h2>
            <p className="mb-4">
              You agree not to use ETERA to redirect users to malicious, illegal, or harmful content. We reserve the right to immediately deactivate any QR code and terminate the associated account if the link points to:
            </p>
            <ul className="list-none space-y-3 font-bold">
              <li className="flex items-start gap-3">
                <span className="bg-black text-white px-2 py-0.5 text-xs mt-1 shrink-0">!</span>
                Illegal content or activities.
              </li>
              <li className="flex items-start gap-3">
                <span className="bg-black text-white px-2 py-0.5 text-xs mt-1 shrink-0">!</span>
                Malware, viruses, or harmful code.
              </li>
              <li className="flex items-start gap-3">
                <span className="bg-black text-white px-2 py-0.5 text-xs mt-1 shrink-0">!</span>
                Phishing sites or scams.
              </li>
              <li className="flex items-start gap-3">
                <span className="bg-black text-white px-2 py-0.5 text-xs mt-1 shrink-0">!</span>
                Spam or highly deceptive content.
              </li>
            </ul>
            <p className="mt-4 text-sm font-black uppercase text-red-600">
              No refunds will be provided for any QR codes or accounts deactivated due to a violation of this Anti-Abuse Policy.
            </p>
          </section>

          <section>
            <h2 className="text-2xl md:text-3xl font-black uppercase mb-6 text-black tracking-tight">
              4. Limitation of Liability
            </h2>
            <p className="mb-6">
              ETERA provides its services strictly on an "as is" and "as available" basis. To the maximum extent permitted by law, we are not liable for any direct, indirect, or consequential losses (financial, reputational, or otherwise) resulting from service downtime, technical errors, or the temporary or permanent loss of access to a redirect.
            </p>
            <div className="p-6 bg-yellow-300 border-[3px] border-black brutal-shadow-sm">
              <h3 className="font-black uppercase text-sm mb-2">Specific Waiver for Printed Materials:</h3>
              <p className="text-base font-bold">
                ETERA specifically offers no compensation or reimbursement for costs incurred from printing our QR codes on physical materials (including, but not limited to, menus, billboards, product packaging, and business cards) in the event of a service interruption, link failure, or business closure. You assume all risks associated with printing dynamic QR codes.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl md:text-3xl font-black uppercase mb-6 text-black tracking-tight">
              5. Changes to the Service or Terms
            </h2>
            <p>
              We reserve the right to modify or discontinue parts of our service, or update these Terms of Service at any time. If we make significant changes to these Terms, we will notify registered users via email. Continued use of ETERA after changes are published constitutes your acceptance of the new Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl md:text-3xl font-black uppercase mb-6 text-black tracking-tight">
              6. Governing Law and Jurisdiction
            </h2>
            <p>
              These Terms of Service are governed by and construed in accordance with the laws of <strong>Spain</strong>. Any disputes arising from these Terms or your use of ETERA shall be subject to the exclusive jurisdiction of the courts located in <strong>Barcelona, Spain</strong>.
            </p>
          </section>

          <section className="pt-8 border-t-4 border-black">
            <h2 className="text-2xl font-black uppercase mb-4 text-black">7. Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us at:
              <br />
              <a href="mailto:support@etera.store" className="text-blue-600 font-black hover:underline decoration-2 underline-offset-4">
                support@etera.store
              </a>
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t-4 border-black text-center">
          <p className="text-xs font-black uppercase tracking-[0.3em] text-gray-400">
            ETERA.STORE — BUILT TO LAST.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;